const ErrorUtil = {
  registerError(error, errorInfo) {
    this.logError(error, errorInfo);
  },
  logError(error, errorInfo) {
    if (errorInfo == null) {
      console.error("Unexpected error", error);
    } else {
      console.error(error, errorInfo);
    }
  }
};
export {
  ErrorUtil as default
};
